module.exports = ['$scope', '$routeParams', 'railsResource',
  function ($scope, $routeParams, $resource) {
    const Portfolio = $resource('/portfolios/:id', { id: '@id' });

    this.portfolio = Portfolio.get({ id: $routeParams.id, include_bac_summary: true });

    this.listPath = () => 'portfolio-models';

    this.editPath = () => `portfolios/${this.portfolio.id}/edit`;

    this.hasAllocationDeviations = () => this.portfolio.bacSummary.currentAllocationsTotal !== 0
      && this.portfolio.bacSummary.targetAllocationsTotal !== 0;

    this.getDeviationStyleClass = (deviation) => {
      let exceedsAllowable = '';

      const allowable = this.portfolio.bacSummary.allowableDeviationRange;
      if (allowable && allowable > 0) {
        exceedsAllowable = (Math.abs(deviation) > allowable) ? ' strong' : '';
      }

      if (deviation > 0) {
        return `positive${exceedsAllowable}`;
      } else if (deviation < 0) {
        return `negative${exceedsAllowable}`;
      }

      return '';
    };

    this.getTotalStyleClass = (total) => (total !== 1 ? 'error strong' : '');

    return this;
  },
];
